import { render, staticRenderFns } from "./q2.vue?vue&type=template&id=515eadd8&scoped=true&"
import script from "./q2.vue?vue&type=script&lang=js&"
export * from "./q2.vue?vue&type=script&lang=js&"
import style0 from "./q2.vue?vue&type=style&index=0&id=515eadd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515eadd8",
  null
  
)

export default component.exports